import {
  Alert,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  Question,
  QuestionOption,
  QuestionTypeEnum,
} from "../models/question.model";
import PreviewImageContainer from "../components/PreviewImageContainer";
import { AnyObject } from "../models/base.model";

export const getQuestionAndAnswers = (questions: Question[], answer: AnyObject) => {
  const rows: {
    key: string;
    question: string;
    answer: string;
  }[] = [
    {
      key: "storeName",
      question: "The store that you visited",
      answer: answer["storeName"] || "",
    },
  ];
  Object.keys(answer).forEach((a) => {
    if (a.indexOf("question") >= 0) {
      const question = questions.find((q) => a.indexOf(q.id) >= 0);
      try {
        if (question && question.type !== QuestionTypeEnum.multipleRowColumnRadio) {
          const existed = rows.find((a) => a.key === question.id);
          const allOptions = question.options.concat(
            question.options.reduce((p, c) => p.concat(c.subOptions || []), [] as QuestionOption[])
          );
          const foundAnswer = (Array.isArray(answer[a]) ? answer[a] : [answer[a]])
            .map((s: string) => allOptions.find((o) => o.key === s)?.label)
            .join(",");
          if (existed) {
            existed.answer = [existed.answer, foundAnswer].join(",");
          } else {
            rows.push({
              key: question.id,
              question: question.content,
              answer: foundAnswer,
            });
          }
        } else if (question && question.type === QuestionTypeEnum.multipleRowColumnRadio) {
          const option = question.options.find((o) => a.indexOf(o.key) >= 0);
          rows.push({
            key: a,
            question: option?.label || "",
            answer: option?.subOptions?.find((c) => c.key === answer[a])?.label || "",
          });
        }
      } catch (error) {
        console.error("error in get answer", error);
      }
    } else {
      const question = questions.find((q) => q.options.find((c) => c.key === a));
      if (question) {
        try {
          rows.push({
            key: question.id,
            question: question.content,
            answer:
              question.type === QuestionTypeEnum.imageVideo ? (
                <div>
                  {answer[a].map((c: any) => (
                    <PreviewImageContainer url={c.url} width={40} height={40} />
                  ))}
                </div>
              ) : (
                answer[a]
              ),
          });
        } catch (error) {
          console.error("error in get answer", error);
        }
      }
    }
  });
  return rows;
};

export default function SurveySubmitAnswerView(props: { answers?: AnyObject; questions?: Question[] }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  let answer: any;
  const { answers, questions = [] } = props;

  try {
    answer = { ...answers };
  } catch (error) {
    console.error("parse answer wrong", answers);
  }

  return answer ? (
    <div>
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  color: "white",
                  backgroundColor: "grey",
                }}
                width={!isMobile ? 400 : 200}
              >
                Question
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  color: "white",
                  backgroundColor: "grey",
                }}
                align="right"
              >
                Answer
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {getQuestionAndAnswers(questions, answer).map((row) => (
              <TableRow key={row.key} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                <TableCell width={!isMobile ? 400 : 200} component="th" scope="row">
                  {row.question}
                </TableCell>
                <TableCell align="right" sx={{ wordBreak: "break-all" }}>
                  {row.answer}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  ) : (
    <Alert severity="error" variant="filled">
      Cannot get correct answer.
    </Alert>
  );
}
